import React, { useState } from "react";
import TablePagesTitle from "../../components/table-pages-title/TablePagesTitle";
import AccessPageAction from "../accessmanagment/page-action/AccessPageAction";
import { useNavigate } from "react-router-dom";
import { showToast } from "../../utils/utils";
import SalesLeadDatePicker from "../../components/datepicker/SalesLeadDatePicker";
import { activeStatusOptions } from "./selectData";
import {
  bannerNotiText,
  fieldValidation,
  createbannerNoti,
  createAccPage,
  buttonName,
  alertActions
} from "../../locales/en";
import { showToastType } from "../../utils/constants/appConstants";
import { getBannerNotificationURL } from "../../utils/constants/apiEndPoints";
import privateAxios from "../../utils/axiosPrivate";
import { sanitizeInput } from "../../utils/utils";
import { BANNER_NOTIFICATIONS } from "../../route/paths";

export default function CreateBannerNotification() {
  const history = useNavigate();

  const initialBannerNotifctn = {
    title: "",
    message: "",
    expiresAt: null,
    isActive: true
  };
  const [bannernotifctn, setbannernotifctn] = useState(initialBannerNotifctn);

  const initialErrors = {};
  const [errors, setErrors] = useState(initialErrors);

  const onInputChange = (event) => {
    const { name, value } = event.target;

    setbannernotifctn((prevState) => ({
      ...prevState,
      [name]: sanitizeInput(value)
    }));

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: ""
    }));
  };

  const handleDateChange = (field, selectedDate) => {
    setbannernotifctn((prevState) => ({
      ...prevState,
      [field]: selectedDate
    }));
  };

  const validate = () => {
    const tempErrors = {};

    if (!bannernotifctn.title || bannernotifctn.title.trim() === "") {
      tempErrors.title = fieldValidation.required;
    }

    if (!bannernotifctn.message) tempErrors.message = fieldValidation.required;

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) {
      return;
    }

    try {
      const dataTosend = {
        title: sanitizeInput(bannernotifctn.title),
        message: sanitizeInput(bannernotifctn.message),
        expiresAt: bannernotifctn.expiresAt,
        isActive: sanitizeInput(bannernotifctn.isActive)
      };

      const response = await privateAxios.post(
        getBannerNotificationURL,
        dataTosend
      );

      if (response.status === 201) {
        showToast(response.data.message, showToastType.success);
      }

      history(BANNER_NOTIFICATIONS);
    } catch (error) {
      if (error.response.status === 409) {
        showToast(error.response.data.errors, showToastType.error);
      } else {
        showToast(error.response.data.message, showToastType.error);
      }
    }
  };

  const handleCancel = () => {
    history(BANNER_NOTIFICATIONS);
  };

  return (
    <>
      <TablePagesTitle mainTitle={bannerNotiText.mainTitle} />
      <AccessPageAction
        subheading={createbannerNoti.subheading}
        alluser="/admin/banner-notifications"
        allUserTitle={bannerNotiText.allUserBtn}
      />

      <div className="row mb-3 mx-0">
        <div className="col-md-12 sale-leade-form mt-3">
          <form onSubmit={handleSubmit}>
            <div className="row mb-2">
              <div className="col-sm-4">
                <div className="input-title">
                  <label htmlFor="title">{createbannerNoti?.title}</label>
                </div>
              </div>
              <div className="col-sm-8">
                <div className="input-group">
                  <input
                    type="text"
                    name="title"
                    placeholder="Title"
                    onChange={onInputChange}
                    value={bannernotifctn.title}
                  />
                  {errors.title && (
                    <div className="text-danger small">{errors.title}</div>
                  )}
                </div>
              </div>
            </div>

            <div className="row mb-2">
              <div className="col-sm-4">
                <div className="input-title">
                  <label htmlFor="message">{createbannerNoti?.message}</label>
                </div>
              </div>
              <div className="col-sm-8">
                <div className="input-group">
                  <textarea
                    type="text"
                    placeholder="Message"
                    name="message"
                    onChange={onInputChange}
                    value={bannernotifctn.message}
                  />
                  {errors.message && (
                    <div className="text-danger small">{errors.message}</div>
                  )}
                </div>
              </div>
            </div>

            <div className="row mb-2">
              <div className="col-sm-4">
                <div className="input-title">
                  <label htmlFor="expireAt">{createbannerNoti?.expireAt}</label>
                </div>
              </div>
              <div className="col-sm-8">
                <div className="input-group">
                  <SalesLeadDatePicker
                    value={bannernotifctn.expiresAt}
                    onChange={(selectedDate) =>
                      handleDateChange("expiresAt", selectedDate)
                    }
                  />
                  {errors.expiresAt && (
                    <div className="text-danger small">{errors.expiresAt}</div>
                  )}
                </div>
              </div>
            </div>

            <div className="row mb-2">
              <div className="col-sm-4">
                <div className="input-title">
                  <label htmlFor="status">{createAccPage.status}</label>
                </div>
              </div>
              <div className="col-sm-8">
                <div className="input-group">
                  <select
                    id="status"
                    name="isActive"
                    onChange={onInputChange}
                    value={bannernotifctn.isActive}
                  >
                    {activeStatusOptions.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>

            <div className="row mt-4">
              <div className="col-sm-8 offset-sm-5 d-flex d-sm-block justify-content-center justify-content-sm-start">
                <button
                  type="button"
                  className="btn btn-red me-2"
                  onClick={handleCancel}
                >
                  {alertActions?.Cancel}
                </button>
                <button type="submit" className="btn btn-primary">
                  {buttonName?.create}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
